import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { TONE } from '../../data/constants'
import Chip from '../Chip/Chip'

export default function UnavailableCell({ messageId = 'AI_RISK_REPORT.UNAVAILABLE' }) {
  return (
    <Chip tone={TONE.NEUTRAL}>
      <FormattedMessage id={messageId} />
    </Chip>
  )
}

UnavailableCell.propTypes = {
  messageId: PropTypes.string,
}
